import Swap from "./hardhat/artifacts/contracts/Swap.sol/Swap.json"
import Token from "./hardhat/artifacts/contracts/Swap.sol/ERC20.json"
import { ethers } from 'ethers';
import Decimal from "decimal.js"

import { Button, Input, message } from 'antd';
import { IntlProvider, FormattedMessage } from 'react-intl';
import messages from './lang/index';
import { useState } from 'react';



let SwapAddr = "0xD32a7Ac307AfC06C57856740aE070308b86fF25a"
let EHAddr = "0xCb0529ae184227573217c3482182dDCdD14Ac830";
let EBWAddr = "0xaA4cfc66fef889CAF3ddB770b0A3bbB4fABA6415";

let SwapContract;
let EHContract;
let EBWContract;


let Provider;
let account;
let chainInfo;
let connWallet;
let Mainnet = true;


function App() {
  const [locale, setLocale] = useState(localStorage.getItem('locale') || 'zh');
  const [Account, setAccount] = useState();

  const [DefaultInputBurnValue, setDefaultInputBurnValue] = useState(locale === 'zh' ? '请输入交换数量' : 'Please enter the exchange quantity');

  const [ConnectWalletLoading, setConnectWalletLoading] = useState(false)
  const [SwapValue, setSwapValue] = useState();
  const [SwapValues, setSwapValues] = useState();
  const [ButtonStatus, setButtonStatus] = useState(false);

  function isMetaMaskInstalled() {
    //Have to check the ethereum binding on the window object to see if it's installed
    const { ethereum } = window;
    return Boolean(ethereum && ethereum.isMetaMask);
  }

  let ConnectWallet = async () => {
    try {
      if (isMetaMaskInstalled()) {
        if (connWallet) {
          return
        }
        setConnectWalletLoading(true);
        await GetAccount();
        Provider = new ethers.providers.Web3Provider(window.ethereum);
        SwapContract = new ethers.Contract(SwapAddr, Swap.abi, Provider.getSigner());
        EHContract = new ethers.Contract(EHAddr, Token.abi, Provider.getSigner());
        EBWContract = new ethers.Contract(EBWAddr, Token.abi, Provider.getSigner());

        //deposit = await SwapContract.deposit();
        await chainChanged();
        await GetGameInfo();
        setConnectWalletLoading(false);
        Provider.on('block', async (blockNumber) => {
          //console.log("blockNumber:", blockNumber)
          await GetGameInfo();
        });
        window.ethereum.on('chainChanged', async function () {
          if (connWallet) {
            connWallet = false;
            await ConnectWallet()
            await GetAccount();
          }

        })
        window.ethereum.on('accountsChanged', async function () {
          //if (connWallet) {
          connWallet = false;
          await ConnectWallet()
          await GetAccount();
          //}
        })
      }

    } catch (err) {
      setConnectWalletLoading(false);
      console.log(err)
    }

  }

  let ConnectWalletButton = () => {
    try {
      if (Account) {
        return Account;
      } else {
        return (<FormattedMessage id="link" />);
      }
    } catch (err) {
      console.log(err)
    }
  }

  let GetAccount = async () => {
    try {
      await window.ethereum.request({ method: 'eth_requestAccounts' })
        .then((accounts) => {
          account = accounts[0];
        }).catch((error) => {
          console.error(error)
        });
    } catch (err) {
      console.log(err)
    }

  }

  let chainChanged = async () => {
    try {
      Provider = new ethers.providers.Web3Provider(window.ethereum);
      chainInfo = await Provider.getNetwork();
      if (Mainnet) {
        if (chainInfo.chainId !== 131419) {
          setAccount("Please switch to the ETND main network");
          await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: '0x2015b' }],
          });
        } else {
          setAccount(account.substring(0, 10) + '...' + account.substring(33, 42).toString());
        }
      } else {
        //if (chainInfo.chainId !== 31337) {
        if (chainInfo.chainId !== 5) {
          setAccount("Please switch to the ETND network");
          await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: '0x2015b' }],
          });
        } else {
          setAccount(account.substring(0, 10) + '...' + account.substring(33, 42).toString());
        }
      }
    } catch (err) {
      Provider = new ethers.providers.Web3Provider(window.ethereum);
      chainInfo = await Provider.getNetwork();

      if (Mainnet) {
        if (chainInfo.chainId !== 131419) {
          setAccount("Please switch to the ETND main network");
          await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: '0x2015b' }],
          });
        } else {
          setAccount(account.substring(0, 10) + '...' + account.substring(33, 42).toString());
        }
      } else {
        //if (chainInfo.chainId !== 31337) {
        if (chainInfo.chainId !== 131419) {
          setAccount("Please switch to the ETND network");
          await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: '0x2015b' }],
          });
        } else {
          setAccount(account.substring(0, 10) + '...' + account.substring(33, 42).toString());
        }
      }
      console.log(err)
    }
    connWallet = true;
  }


  let GetGameInfo = async () => {
    try {
      
    } catch (err) {
      console.log(err)
    }
  }

  let swapv = async () => {
    try {
      if(new Decimal(SwapValue).lessThan("1")){
        if(locale === 'zh'){
          message.warning("最低 1 EBW", 1);
          return
        }else{
          message.warning("Minimum 1 EBW", 1);
          return
        }
        
        
      }

      if(!connWallet){
        if(locale === 'zh'){
          message.warning("请先连接钱包", 1);
          return 
        }else{
          message.warning("Please connect the wallet first", 1);
          return 
        }
      }

      let _value = Decimal(SwapValue.toString()).mul(Decimal("1000000000000000000"));
      setButtonStatus(true);
      let tx = await EBWContract.approve(SwapAddr,_value.toString());
      await tx.wait()
      setButtonStatus(false);
      setButtonStatus(true);
      let _tx = await SwapContract.swap(_value.toString());
      await _tx.wait()
      setButtonStatus(false);
    } catch (err) {
      setButtonStatus(false);
      console.log(err)
    }
  }

  // 切换语言
  const onToggleLocale = () => {
    let _locale = locale === 'zh' ? 'en' : 'zh';
    localStorage.setItem('locale', _locale);
    setDefaultInputBurnValue(locale === 'zh' ? 'Please enter the exchange quantity' : '请输入交换数量');
    setLocale(_locale);
    
  }


  return (
    <IntlProvider key={locale} locale={locale} messages={messages[locale]}>
      <div className="max-width-500 w-100 h-100 px-3 text-md color-white overflow-auto slim-no-scroll pt-3 pb-5">
        <header className="d-flex align-items-center justify-content-between mb-3 color-purple-5">
          <Button className="ant-btn-purple" onClick={ConnectWallet} loading={ConnectWalletLoading}>
            <ConnectWalletButton />
          </Button>
          <div onClick={onToggleLocale} className="flex-center-center">
            <svg t="1660977407777" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3411" width="1.4rem" height="1.4rem"><path d="M512.9 960.2c-245.5 0-445.3-199.8-445.3-445.3S267.4 69.6 512.9 69.6c97.2 0 189.6 30.8 267.1 89 15.1 11.4 18.2 32.8 6.8 48-11.4 15.1-32.8 18.2-48 6.8-65.6-49.2-143.7-75.2-226-75.2C305 138.2 136 307.2 136 515s169 376.8 376.8 376.8 376.8-169 376.8-376.8c0-48.5-9.1-95.8-27-140.4-7.1-17.6 1.5-37.5 19-44.6 17.6-7.1 37.5 1.5 44.6 19 21.2 52.8 32 108.6 32 165.9 0 245.6-199.7 445.3-445.3 445.3z" fill="#d5c7fc" p-id="3412"></path><path d="M829.1 273.3m-39.5 0a39.5 39.5 0 1 0 79 0 39.5 39.5 0 1 0-79 0Z" fill="#d5c7fc" p-id="3413"></path><path d="M523.6 954.4c-6.3 0-12.6-2.2-17.8-6.6-16.1-13.7-31.6-28.6-46.1-44.3-45.5-48.9-81.4-104.9-106.8-166.5-27.4-66.3-41.4-136.5-41.9-208.8v-3.5c0-61.6 10.1-122.2 29.8-180 28.8-84.1 78.2-161.2 143-222.8 4.9-4.7 10-9.3 15.1-13.8 11.3-10 28.7-9 38.7 2.4 10 11.3 9 28.7-2.4 38.7-4.6 4.1-9.2 8.3-13.6 12.5-58.3 55.6-102.9 125-128.9 200.8-17.8 52.1-26.9 106.7-26.9 162.3v3.3c0.4 65 13.1 128.3 37.7 188 22.9 55.5 55.3 106 96.3 150.1 13.1 14.2 27.1 27.6 41.5 39.9 11.5 9.8 12.9 27.1 3 38.6-5.2 6.4-12.9 9.7-20.7 9.7z" fill="#d5c7fc" p-id="3414"></path><path d="M487.4 953.1c-8.4 0-16.6-3.8-22-11-9.1-12.1-6.6-29.3 5.6-38.4 16-11.9 31.4-25 45.9-38.7 43.8-41.7 79.3-90.2 105.5-144.3 29.6-60.8 46.3-126.1 49.6-193.9 0.4-8.5 0.6-16.9 0.6-25 0-43.4-5.5-86.6-16.5-128.1-20.8-79.2-61.5-153-117.5-213.3-4-4.4-8.3-8.8-13.2-13.7-10.7-10.7-10.8-28-0.1-38.8 10.7-10.7 28-10.8 38.8-0.1 5.6 5.5 10.4 10.6 14.9 15.5 62 66.7 107.1 148.5 130.2 236.5 12.1 46.1 18.3 93.9 18.3 142.1 0 9-0.2 18.3-0.7 27.6-3.7 75.3-22.2 147.7-55.1 215.2-29.1 60-68.5 113.8-117 160-16 15.3-33.1 29.7-50.9 42.9-5 3.7-10.7 5.5-16.4 5.5z" fill="#d5c7fc" p-id="3415"></path><path d="M834.9 747.1c-5.3 0-10.7-1.5-15.4-4.8-58.1-39.7-122.1-67.9-190.2-83.9-42.6-10-86.6-15.1-130.8-15.1h-0.2c-33.2 0-66.3 2.8-98.6 8.5-73 12.7-142 39.3-204.9 78.9-12.8 8.1-29.7 4.2-37.8-8.6-8.1-12.8-4.2-29.7 8.6-37.8 69-43.4 144.6-72.5 224.7-86.5 35.4-6.2 71.7-9.3 108-9.3h0.2c48.4 0 96.6 5.6 143.3 16.6 74.7 17.5 144.9 48.5 208.6 92 12.5 8.5 15.7 25.6 7.2 38.1-5.4 7.7-14 11.9-22.7 11.9zM924 480.5l-801.8-0.3c-15.1 0-27.4-12.3-27.4-27.4 0-15.1 12.3-27.4 27.4-27.4l801.8 0.3c15.1 0 27.4 12.3 27.4 27.4 0 15.2-12.3 27.4-27.4 27.4z" fill="#d5c7fc" p-id="3416"></path></svg>
            <div className="ml-1">{locale.toUpperCase()}</div>
          </div>
        </header>
        <div className="flex-item align-items-center mt-5">EBW</div>
        <div className="flex-item align-items-center mt-5">
          <Input className="flex-content input-background" value={SwapValue} placeholder={DefaultInputBurnValue} onChange={(event) => {
            if(!connWallet){
              if(locale === 'zh'){
                message.warning("请先连接钱包", 1);
              }else{
                message.warning("Please connect the wallet first", 1);
              }
              return
            }
            setSwapValue(event.target.value)
            setSwapValues(event.target.value / 2)
          }} />
        </div>
        
        <div className=" mt-5 text-center">↓</div>
        <div className="flex-item align-items-center ">EH</div>
        
        <div className="flex-item align-items-center mt-5">
          <Input className="flex-content input-background" value={SwapValues} onChange={(event) => {
            if(!connWallet){
              if(locale === 'zh'){
                message.warning("请先连接钱包", 1);
              }else{
                message.warning("Please connect the wallet first", 1);
              }
              return
            }
            setSwapValue(event.target.value * 2)
            setSwapValues(event.target.value )
          }} />
        </div>


        <div className="flex-item align-items-center mt-5">
        <Button className="flex-label ant-btn-warning" onClick={async () => {
          if(!connWallet){
            if(locale === 'zh'){
              message.warning("请先连接钱包", 1);
            }else{
              message.warning("Please connect the wallet first", 1);
            }
            return
          }
          await swapv();
          }} loading = {ButtonStatus}>
            <FormattedMessage id="swap" />
          </Button>
        </div>


      </div>

    </IntlProvider>
  );
}

export default App;
